<div>
  <div class="image-box">
    <img
      #sourceImage
      (load)="imageLoadedInView()"
      [src]="safeImgDataUrl"
      [style.visibility]="imageVisible ? 'visible' : 'hidden'"
      class="source-image"
    />
  </div>

  <div
    *ngIf="imageVisible"
    [class.rounded]="roundCropper"
    [style.height.px]="cropper.y2 - cropper.y1"
    [style.left.px]="cropper.x1"
    [style.margin-left]="alignImage === 'center' ? marginLeft : null"
    [style.top.px]="cropper.y1"
    [style.visibility]="imageVisible ? 'visible' : 'hidden'"
    [style.width.px]="cropper.x2 - cropper.x1"
    class="cropper"
  >
    <div
      (mousedown)="startMove($event, 'move')"
      (touchstart)="startMove($event, 'move')"
      class="move"
    >
      &nbsp;
    </div>
    <span
      (mousedown)="startMove($event, 'resize', 'topleft')"
      (touchstart)="startMove($event, 'resize', 'topleft')"
      class="resize topleft"
    ><span class="square"></span
    ></span>
    <span class="resize top"><span class="square"></span></span>
    <span
      (mousedown)="startMove($event, 'resize', 'topright')"
      (touchstart)="startMove($event, 'resize', 'topright')"
      class="resize topright"
    ><span class="square"></span
    ></span>
    <span class="resize right"><span class="square"></span></span>
    <span
      (mousedown)="startMove($event, 'resize', 'bottomright')"
      (touchstart)="startMove($event, 'resize', 'bottomright')"
      class="resize bottomright"
    ><span class="square"></span
    ></span>
    <span class="resize bottom"><span class="square"></span></span>
    <span
      (mousedown)="startMove($event, 'resize', 'bottomleft')"
      (touchstart)="startMove($event, 'resize', 'bottomleft')"
      class="resize bottomleft"
    ><span class="square"></span
    ></span>
    <span class="resize left"><span class="square"></span></span>
    <span
      (mousedown)="startMove($event, 'resize', 'top')"
      (touchstart)="startMove($event, 'resize', 'top')"
      class="resize-bar top"
    ></span>
    <span
      (mousedown)="startMove($event, 'resize', 'right')"
      (touchstart)="startMove($event, 'resize', 'right')"
      class="resize-bar right"
    ></span>
    <span
      (mousedown)="startMove($event, 'resize', 'bottom')"
      (touchstart)="startMove($event, 'resize', 'bottom')"
      class="resize-bar bottom"
    ></span>
    <span
      (mousedown)="startMove($event, 'resize', 'left')"
      (touchstart)="startMove($event, 'resize', 'left')"
      class="resize-bar left"
    ></span>
  </div>
</div>
